import Login from "auth/login";
import Register from "auth/register";
import UserProfile from "layouts/user-profile";
import Dashboard from "layouts/dashboard";
import AddKarkun from "layouts/karkun-management/create";
import EditKarkun from "layouts/karkun-management/edit";
import KarkunManagement from "layouts/karkun-management";
import KarkunDetail from "layouts/karkun-management/detail";
import CenterDetail from "layouts/Center-management/detail";
import AddCenter from "layouts/Center-management/create";
import EditCenter from "layouts/Center-management/edit";
import CenterManagement from "layouts/Center-management";
import MeetingManagement from "layouts/Meeting-management";
import AttendanceManagement from "layouts/Attendance-management";
import AttendanceDetail from "layouts/Attendance-management/details";
import AddMeeting from "layouts/Meeting-management/create";
import MeetingDetail from "layouts/Meeting-management/details";
import RolesManagement from "layouts/roles-management";
import CreateRoles from "layouts/roles-management/create";
import EditRole from "layouts/roles-management/edit";
import RoleDetail from "layouts/roles-management/detail";
import EditMeeting from "layouts/Meeting-management/edit";
import MarkAttendance from "layouts/Attendance-management/create";
import KarkunVerifyDevice from "layouts/karkun-management/KarkunVerifyDevice";
import VerifyAttendance from "layouts/Attendance-management/VerifyAttendance";
import FundsManagement from "layouts/Funds-management";
import AddFunds from "layouts/Funds-management/create";
import FundsDetail from "layouts/Funds-management/details";
import EditFund from "layouts/Funds-management/edit";


const routeConfig = [
  {
    path: "/auth/login",
    component: Login,
    permissions: [],
  },
  {
    path: "/auth/register",
    component: Register,
    permissions: [],
  },
  {
    path: "/dashboard",
    component: Dashboard,
    permissions: [],
  },
  {
    path: "user-profile",
    component: UserProfile,
    permissions: [],
  },
  {
    path: "centers",
    component: CenterManagement,
    permissions: ["center:view", "center:all"],
  },
  {
    path: "centers/:id/edit",
    component: EditCenter,
    permissions: ["center:edit", "center:all"],
  },
  {
    path: "centers/create",
    component: AddCenter,
    permissions: ["center:create", "center:all"],
  },
  {
    path: "centers/:id/detail",
    component: CenterDetail,
    permissions: ["center:view", "center:all"],
  },
  {
    path: "karkuns",
    component: KarkunManagement,
    permissions: ["karkun:view", "karkun:all"],
  },
  {
    path: "karkuns/:id/edit",
    component: EditKarkun,
    permissions: ["karkun:edit", "karkun:all"],
  },
  {
    path: "karkuns/create",
    component: AddKarkun,
    permissions: ["karkun:create", "karkun:all"],
  },
  {
    path: "karkuns/:id/detail",
    component: KarkunDetail,
    permissions: ["karkun:view", "karkun:all"],
  },
  {
    path: "karkuns/device-verify",
    component: KarkunVerifyDevice,
    permissions: [],
    isPublic: true,
  },
  {
    path: "meeting",
    component: MeetingManagement,
    permissions: ["meeting:view", "meeting:all"],
  },
  {
    path: "meeting/create",
    component: AddMeeting,
    permissions: ["meeting:create", "meeting:all"],
  },
  {
    path: "meeting/:id/detail",
    component: MeetingDetail,
    permissions: ["meeting:view", "meeting:all"],
  },
  {
    path: "meeting/:id/edit",
    component: EditMeeting,
    permissions: ["meeting:edit", "meeting:all"],
  },
  {
    path: "attendance/karkun-attendance-verify",
    component: VerifyAttendance,
    permissions: [],
    isPublic: true,
  },
  {
    path: "attendance",
    component: AttendanceManagement,
    permissions: ["attendance:view", "attendance:all"],
  },
  {
    path: "attendance/mark",
    component: MarkAttendance,
    permissions: ["attendance:mark", "attendance:all"],
  },
  {
    path: "attendance/:id/detail",
    component: AttendanceDetail,
    permissions: ["attendance:view", "attendance:all"],
  },
  {
    path: "funds",
    component: FundsManagement,
    permissions: [],
  },
  {
    path: "funds/create",
    component: AddFunds,
    permissions: [],
  },
    {
    path: "funds/:id/edit",
    component: EditFund,
    permissions: [],
  },
  {
    path: "funds/:id/detail",
    component: FundsDetail,
    permissions: [],
  },
  {
    path: "roles",
    component: RolesManagement,
    permissions: ["roles:view", "roles:all"],

  },
  {
    path: "roles/create",
    component: CreateRoles,
    permissions: ["roles:create", "roles:all"],

  },
  {
    path: "roles/:id/edit",
    component: EditRole,
    permissions: ["roles:edit", "roles:all"],

  },
  {
    path: "roles/:id/detail",
    component: RoleDetail,
    permissions: ["roles:view", "roles:all"],

  },
];

export default routeConfig;